import { lazyWithPreload } from 'helpers/lazyWithPreload'

export const Email = lazyWithPreload(() => import('./Email'))
export const EmailConsent = lazyWithPreload(() => import('./EmailConsent'))
export const LikeChatEmail = lazyWithPreload(() => import('./LikeChatEmail'))
export const LikeChatEmailConsent = lazyWithPreload(
  () => import('./LikeChatEmailConsent'),
)
export const EmailVariant2 = lazyWithPreload(() => import('./EmailVariant2'))
